export default "__VITE_ASSET__Bq1nfYji__"